export default "__VITE_ASSET__BMqExUUu__"